/**
 * Small action button for the right-hand actions column of a table.
 * Matches the "Modify" button DataTable renders, so both tables read alike.
 */
const VARIANTS = {
  default:
    'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50',
  primary:
    'border-sky-200 bg-sky-50 text-sky-700 hover:border-sky-300 hover:bg-sky-100',
};

export default function TableActionButton({ children, onClick, variant = 'default', ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center rounded-lg border px-2.5 py-1 text-xs font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
        VARIANTS[variant] || VARIANTS.default
      }`}
      {...props}
    >
      {children}
    </button>
  );
}
